import { Fragment } from "react";
import CreateCategoryModal from "./createCategory";
import UpdateCategoryModal from "./updateCategory";
import DeleteCategoryModal from "./deleteCategory";
import CreateMenuCategoryModal from "./createMenuCategory";
import UpdateMenuCategoryModal from "./updateMenuCategory";
import DeleteMenuCategoryModal from "./deleteMenuCategory";
import CreateDailyMenuModal from "./createDailyMenu";
import UpdateDailyMenuModal from "./updateDailyMenu";
import DeleteDailyMenuModal from "./deleteDailyMenu";
import CreateCustomerModal from "./createCustomer";
import DeleteCustomerModal from "./deleteCustomer";
import CreateSupplierModal from "./createSupplier";
import DeleteSupplierModal from "./deleteCustomer";
import DeleteSalesOrderModal from "./deleteSalesOrder";
import DeleteSalesOrderEditRequestModal from "./deleteSalesOrderEditRequest";
import DeleteInvoiceModal from "./deleteInvoice";
import CreatePaymentModal from "./createPayment";
import UpdatePaymentModal from "./updatePayment";
import DeletePaymentModal from "./deletePayment";
import ConfirmPaymentModal from "./confirmPayment";
import CreateCreditModal from "./createCredit";
import ViewInvoiceModal from "./viewInvoice";
import ViewReportModal from "./viewReport";
import ViewErrorMessageModal from "./viewErrorMessage";

import CreateColorVariantModal from "./createColorVariant";
import UpdateColorVariantModal from "./updateColorVariant";
import DeleteColorVariantModal from "./deleteColorVariant";
import CreateSizeVariantModal from "./createSizeVariant";
import UpdateSizeVariantModal from "./updateSizeVariant";
import DeleteSizeVariantModal from "./deleteSizeVariant";
import CreateProductModal from "./createProduct";
import UpdateProductModal from "./updateProduct";
import UpdateProductVariantModal from "./updateProductVariant";
import CreateProductVariantModal from "./createProductVariant";
import CreateDeliveryPackingModal from "./createPackingOrder";
import CreateDeliveryStickerModal from "./createDeliverySticker";
import ViewSuccessMsgModal from "./viewSuccessMessage";

import NewReceiveOrderItem from "./confirmCreateReceiveOrder";
import ConfirmReceiveOrderItem from "./confirmReceiveOrderItem";
import CreatePurchaseOrderManual from "./createPurchaseOrderManual";
import ViewQrCodeModal from "./viewQrCode";
import ViewProductCodesModal from "./viewProductCodes";
import CreateDeliveryOrderModal from "./createDeliveryOrder";
import FindProductCodeModal from "./findProductCode";
import ImportSalesOrderWeb from "./importSalesOrderWeb";
import ImportSalesOrderShopee from "./importSalesOrderShopee";
import CreateStockOpnameModal from "./createStockOpname";
import CreateScrapModal from "./createScrap";
import ChooseSalesOrderModal from "./chooseSalesOrder";
import ChooseCustomerModal from "./chooseCustomer";
import ChooseProductModal from "./chooseProduct";
import ScanProductQrCodeModal from "./scanProductQrCode";
import ScanQrProductCodeModal from "./scanQrProductCode";
import ScanQrProductCodeReturCustomerModal from "./scanQrProductCodeReturCustomer";
import ExportScrapExcelModal from "./exportScrapExcel";
import ExportReturSupplierExcelModal from "./exportReturSupplierExcel";
import ExportReturCustomerExcelModal from "./exportReturCustomerExcel";
import ViewReturHistoryModal from "./viewReturHistory";

const registeredItems = {
  "receiveOrderItem.update": NewReceiveOrderItem,
  "receiveOrderItem.confirm": ConfirmReceiveOrderItem,
  "deliveryOrder.packing": CreateDeliveryPackingModal,
  "deliveryOrder.sticker": CreateDeliveryStickerModal,
  "product.create": CreateProductModal,
  "product.update": UpdateProductModal,
  "product.delete": CreateSizeVariantModal,
  "productVariant.create": CreateProductVariantModal,
  "productVariant.update": UpdateProductVariantModal,
  "productVariant.delete": UpdateProductVariantModal,
  "sizeVariant.create": CreateSizeVariantModal,
  "sizeVariant.update": UpdateSizeVariantModal,
  "sizeVariant.delete": DeleteSizeVariantModal,
  "colorVariant.create": CreateColorVariantModal,
  "colorVariant.update": UpdateColorVariantModal,
  "colorVariant.delete": DeleteColorVariantModal,
  "category.create": CreateCategoryModal,
  "category.update": UpdateCategoryModal,
  "category.delete": DeleteCategoryModal,
  "menuCategory.create": CreateMenuCategoryModal,
  "menuCategory.update": UpdateMenuCategoryModal,
  "menuCategory.delete": DeleteMenuCategoryModal,
  "dailyMenu.create": CreateDailyMenuModal,
  "dailyMenu.update": UpdateDailyMenuModal,
  "dailyMenu.delete": DeleteDailyMenuModal,
  "customer.create": CreateCustomerModal,
  "customer.delete": DeleteCustomerModal,
  "supplier.create": CreateSupplierModal,
  "supplier.delete": DeleteSupplierModal,
  "salesOrder.delete": DeleteSalesOrderModal,
  "salesOrder.importweb": ImportSalesOrderWeb,
  "salesOrder.importshopee": ImportSalesOrderShopee,
  "invoice.delete": DeleteInvoiceModal,
  "payment.create": CreatePaymentModal,
  "payment.update": UpdatePaymentModal,
  "payment.delete": DeletePaymentModal,
  "payment.confirm": ConfirmPaymentModal,
  "credit.create": CreateCreditModal,
  "invoice.view": ViewInvoiceModal,
  "report.view": ViewReportModal,
  "errorMessage.view": ViewErrorMessageModal,
  "successMessage.view": ViewSuccessMsgModal,
  "salesOrderEditRequest.delete": DeleteSalesOrderEditRequestModal,
  "purchaseOrder.create-manual": CreatePurchaseOrderManual,
  "qrCode.view": ViewQrCodeModal,
  "productCodes.view": ViewProductCodesModal,
  "deliveryOrder.delivery": CreateDeliveryOrderModal,
  "productCode.find": FindProductCodeModal,
  "stockOpname.create": CreateStockOpnameModal,
  "scrap.create": CreateScrapModal,
  "salesOrder.choose": ChooseSalesOrderModal,
  "customer.choose": ChooseCustomerModal,
  "product.choose": ChooseProductModal,
  "product.scanQrCode": ScanProductQrCodeModal,
  "product.scanQrProductCode": ScanQrProductCodeModal,
  "product.scanQrProductCodeReturCustomer": ScanQrProductCodeReturCustomerModal,
  "exportScrapExcel": ExportScrapExcelModal,
  "exportReturSupplierExcel": ExportReturSupplierExcelModal,
  "exportReturCustomerExcel": ExportReturCustomerExcelModal,
  "returHistory.view": ViewReturHistoryModal,
};

function AppModals({ items = [], onSuccess = {} }) {
  return (
    <Fragment>
      {items.map((item, key) => {
        const Component = registeredItems[item];
        return <Component key={key} onSuccess={onSuccess[item]} />;
      })}
    </Fragment>
  );
}

export default AppModals;
